// SubdomainGuard.jsx
import { useEffect, useState } from "react";
import { useNavigate, useLocation  } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSubdomain } from "./features/subdomainSlice";
import CompanyStatusModal from "./components/CompanyStatusModal";
import { BASE_URL } from "./api";

const SubdomainGuard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [modalType, setModalType] = useState('');

  useEffect(() => {

    const checkSubdomain = async () => {
      if (location.pathname === "/404" || location.pathname.includes("/company") || location.pathname === "/thank-you") return;
      try {
        const hostname =   window.location.hostname; //'http://dev.seishinacademy.bookinclass.co.uk'; //;
        const parts = hostname.split('.');
        
        if (parts.length > 3) {
          
          let subdomain = parts[parts.length - 4];
          
          // Check if subdomain is "register"
          if (subdomain === "register") {
            navigate("/company");
            return;
          }
          
          const response = (await fetch(`${BASE_URL}auth/verifysubdomain/${subdomain}`));
          const res = await response.json();
          console.log(res.code)
          if (!res.code) {
            navigate("/404");
          }else{
            localStorage.setItem("company", JSON.stringify(res.data));
            localStorage.setItem("company_logo", res.data.logo);
            localStorage.setItem("company_name", res.data.company_name);
            localStorage.setItem("banner", res.data.banner);
            
            // Store trial, subscription, and profile completion details
            if (res.data.is_profile_complete !== undefined) {
              localStorage.setItem("is_profile_complete", res.data.is_profile_complete);
            }
            if (res.data.trial_expiry_date) {
              localStorage.setItem("trial_expiry_date", res.data.trial_expiry_date);
            }
            if (res.data.subscription_status !== undefined) {
              localStorage.setItem("subscription_status", res.data.subscription_status);
            }
            if (res.data.subscription_expiry_date) {
              localStorage.setItem("subscription_expiry_date", res.data.subscription_expiry_date);
            }
            
            dispatch(setSubdomain(subdomain));
            
            // Check profile completion
            if (res.data.is_profile_complete === false) {
              setModalType('profile_incomplete');
              setModalShow(true);
            } else {
              // Check trial and subscription status
              const currentDate = new Date();
              const trialExpiry = res.data.trial_expiry_date ? new Date(res.data.trial_expiry_date) : null;
              const subscriptionStatus = res.data.subscription_status;
              const subscriptionExpiry = res.data.subscription_expiry_date ? new Date(res.data.subscription_expiry_date) : null;

              // Check if both trial and subscription are null (no trial, no subscription)
              if (!trialExpiry && !subscriptionStatus) {
                setModalType('trial_expired');
                setModalShow(true);
              }
              // Check if trial is expired and no active subscription
              else if (trialExpiry && currentDate > trialExpiry) {
                if (!subscriptionStatus || subscriptionStatus === 'expired' || (subscriptionExpiry && currentDate > subscriptionExpiry)) {
                  setModalType('trial_expired');
                  setModalShow(true);
                }
              }
              // Check if subscription is expired (but only if subscription status is not active)
              else if (subscriptionStatus && subscriptionStatus !== 'active' && (subscriptionStatus === 'expired' || (subscriptionExpiry && currentDate > subscriptionExpiry))) {
                setModalType('subscription_expired');
                setModalShow(true);
              }
            }
          }
        } else {
          // No subdomain found, navigate to 404
          navigate("/404");
        }

        
      } catch (error) { console.log('error---',error);
        navigate("/404");
      }
    };

    checkSubdomain();
  }, [navigate]);

  return (
    <>
      <CompanyStatusModal
        show={modalShow}
        type={modalType}
        onClose={() => setModalShow(false)}
      />
    </>
  );
};

export default SubdomainGuard;
